import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, type }) {
  const loggedUser = JSON.parse(localStorage.getItem("loggedInUser") || "null");
  const loggedAdmin = JSON.parse(localStorage.getItem("loggedInAdmin") || "null");
  const loginTime = localStorage.getItem("loginTime");

  // 12 hours in ms
  const sessionLimit = 12 * 60 * 60 * 1000;

  // ⏳ Auto logout logic
  if (loginTime) {
    const now = Date.now();
    const timePassed = now - Number(loginTime);

    if (timePassed > sessionLimit) {
      // Clear all login data
      localStorage.removeItem("loggedInUser");
      localStorage.removeItem("loggedInAdmin");
      localStorage.removeItem("loginTime");

      // Force redirect to login
      return <Navigate to="/login" replace />;
    }
  }

  // 🔐 Admin protection
  if (type === "admin" && !loggedAdmin) {
    return <Navigate to="/login" replace />;
  }

  // 🔐 User protection
  if (type === "user" && !loggedUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
